import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { CustomSkill } from '../types';

type SaveCustomSkillParams = {
  id?: string;
  name: string;
  description: string;
  markdown: string;
  requiresSandbox: boolean;
  companyFilesVisible: boolean;
  isEnabled: boolean;
};

export default function useSaveCustomSkill(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: SaveCustomSkillParams) => {
      const body = {
        name: params.name,
        description: params.description,
        markdown: params.markdown,
        requiresSandbox: params.requiresSandbox,
        companyFilesVisible: params.companyFilesVisible,
        isEnabled: params.isEnabled,
      };
      if (params.id) {
        return api.put<CustomSkill>(
          `/admin/companies/${companyId}/custom-skills/${params.id}`,
          body,
        );
      }
      return api.post<CustomSkill>(`/admin/companies/${companyId}/custom-skills`, body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['admin', 'companies', companyId, 'custom-skills'],
      });
    },
  });
}
